import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import type { ICreateGatewayPayload } from "@app/dashboard/types/innerLayout/payment_integrations/create-integrations";
import { AxiosRequestConfig } from "axios";


interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    allow403?: boolean;
};

export const createPaymentIntegration = (payload: ICreateGatewayPayload) => {

    const {
        gateway_type,
        currency,
        is_shopify,
        transaction_processed_callback,
        transaction_response_callback
    } = payload;

    const params = {
        gateway_type,
        currency,
        is_shopify,
        ...(
            transaction_processed_callback && transaction_response_callback ?
                {
                    transaction_response_callback,
                    transaction_processed_callback
                }
                : {}
        )
    };

    return axiosPrivate.post(`/dashboard/api/v1/integrationsv1`, params, { allow403: true } as CustomAxiosRequestConfig);
};

